
import axios from 'axios'
import { toast } from "react-toastify"

// axios.defaults.baseURL = process.env.REACT_APP_BASE_URL

export async function get(url, config = {}) {

    return await axios.get(url, config)
        .then(resposne => resposne.data)
        .catch(error => console.log(error))

}
export async function post(url, data, isFormData) {

    const config = {
        headers: {
            "Content-Type": isFormData ? "multipart/form-data" : "application/json",
        }
    }

    return await axios.post(url, data, config)

        .then(resposne => resposne.data)
        .catch(error => {
            console.log(error); 
            if(url.includes("Excel")) toast.error("نام کاربری یا کلمه عبور اشتباه است")
        })
}